import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './index.module.scss';
import ImageModal from './ImageModal';

const PostImageV1 = ({ contentData, contentName, path_to_folder }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Получаем данные из contentData
  const imgName = contentData?.img_name;

  // Обработка imgName - оставляем только часть после последнего '\'
  const processedImgName =
    imgName && imgName.includes('\\') ? imgName.substring(imgName.lastIndexOf('\\') + 1) : imgName;

  if (!imgName || imgName === 'none') {
    return null;
  }

  // Проверяем, есть ли уже протокол в path_to_folder
  const imageSrc = path_to_folder && (path_to_folder.startsWith('http://') || path_to_folder.startsWith('https://'))
    ? path_to_folder + processedImgName
    : 'https://' + path_to_folder + processedImgName;
  const imageAlt = contentName || 'Изображение поста';

  // console.log('[Карточка поста] маршрут изображения:', imageSrc);

  const handleImageClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className={styles.postImageV1}>
        <div className={styles.imageContainer}>
          <img
            src={imageSrc}
            alt={imageAlt}
            className={styles.image}
            onClick={handleImageClick}
            style={{ cursor: 'pointer' }}
          />
        </div>
      </div>

      {isModalOpen &&
        createPortal(
          <ImageModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            imageSrc={imageSrc}
            imageAlt={imageAlt}
          />,
          document.body,
        )}
    </>
  );
};

export default PostImageV1;
